<deletemodal id="customer-tabs" [deleteModal]="deleteModal"></deletemodal>
<deletemodal id="customer-tabs" [deleteModal]="qtyWarning"></deletemodal>
<modal #closeTicketModal>
    <modal-header>
        <h4 *ngIf="!isTicketClosed">{{'ticketing-system.Close Ticket' |translate | translateKey}}</h4>
        <h4 *ngIf="isTicketClosed">{{'ticketing-system.Reopen Ticket' |translate | translateKey}}</h4>
    </modal-header>
    <modal-content>
        <form  [formGroup]="ticketCloseForm" style="margin-left: -15px;width: 105%;" class="col-xs-12  ticket-color-validation" novalidate >
        <div class="form-group"  *ngIf="!isTicketClosed">
            <label for="{{'ticketing-system.Reason' |translate}}">{{'ticketing-system.Reason' |translate}}*
                    <!-- <span  class="ico-help fa fa-question-circle" title="{{'ticketing-system.Reason' |translate}}"></span> -->
            </label>
            <div>
                <select tabindex="0" class="form-control" formControlName="closedTicketReason">
                    <option value="" [selected]="true">--{{'ticketing-system.Select' |translate | translateKey}}--</option>
                    <option *ngFor="let reason of closedReasons" [value]="reason.id">{{reason.value}}</option>
                </select>
                <div class="alert-msg" *ngIf="!ticketCloseForm.controls['closedTicketReason'].valid && ticketCloseForm.controls['closedTicketReason'].hasError('required') &&(ticketCloseForm.controls['closedTicketReason'].touched|| isSubmitted)">
                    <div *ngIf="ticketCloseForm.controls['closedTicketReason'].errors.required">
                        {{'validation-message.Reason is required'|translate | translateKey}}
                    </div>
                </div>

            </div>
        </div>
        <div class="form-group">
            <label for="{{'ticketing-system.Note' |translate}}">{{'ticketing-system.Note' |translate | translateKey}}
                    <!-- <span  class="ico-help fa fa-question-circle" title="{{'ticketing-system.Note' |translate}}"></span> -->
            </label>
            <div class=" textarea-msg">
                <textarea tabindex="0" class="form-control" placeholder="" formControlName="closedTicketNote" rows="3" ></textarea>
                <div class="alert-msg" *ngIf="!ticketCloseForm.controls['closedTicketNote'].valid && ticketCloseForm.controls['closedTicketNote'].hasError('required') &&(ticketCloseForm.controls['closedTicketNote'].touched|| isSubmitted)">
                    <div *ngIf="ticketCloseForm.controls['closedTicketNote'].errors.required">
                        {{'validation-message.Note is required'|translate | translateKey}}
                    </div>
                </div>
            </div>
        </div>
        </form>
    </modal-content>
    <modal-footer>
        <div class="pull-right">
            <div class="btn-group  btn-save-new">
                <button class="btn btn-default btn-save" type="submit" tabindex="0" (click)="closeTicket()"><i class="fa fa-check pad-r-8"></i>{{'ticketing-system.Save' |translate | translateKey}}</button>
            </div>
            <button class="btn cancel btn-cancel" type="button" tabindex="0" (keyup.enter)="cancelPopup()" (click)="cancelPopup()">
                <i class="fa fa-close pad-r-8"></i>{{'ticketing-system.Cancel' |translate | translateKey}}                                                                                              
            </button>
        </div>
    </modal-footer>
</modal>
<div *ngIf="showViewTicket">
    <div class="page-heading" style="background-color: #f1f1f1; padding-bottom: 7px;">
        <div class="col-md-8">
            <span class="edit-header">
                {{ticketingModel.typeValue}}&nbsp;|&nbsp;{{ticketingModel.subTypeValue}}&nbsp;|&nbsp;{{ticketingModel.subject}}
            </span>
        </div>
        <div class="col-md-4">
            <div class="pull-right">
                <div class="btn-group  btn-save-new" *ngIf="!isTicketClosed && isTicketEditPermission">
                    <button class="btn btn-default btn-save" tabindex="2" (click)="editTicket()" type="button">
                        <i class="fa fa-pencil pad-r-8"></i>{{'ticketing-system.Edit' |translate | translateKey}}</button>
                </div>
                <div class="btn-group  btn-save-new" *ngIf="!isTicketClosed && isTicketClosePermission">
                    <button class="btn btn-default btn-save" tabindex="2" type="button" (click)="openCloseTicketModal(true)">
                        <i class="fa fa-close pad-r-8"></i>{{'ticketing-system.Close Ticket' |translate | translateKey}}
                    </button>
                </div>
                <div class="btn-group  btn-save-new" *ngIf="isTicketClosed && isTicketReopenPermission">
                    <button class="btn btn-default btn-save" tabindex="2" type="button" (click)="openCloseTicketModal(false)">
                        <i class="fa fa-close pad-r-8"></i>{{'ticketing-system.Reopen Ticket' |translate | translateKey}}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!--<div class="title-underline"></div>-->
    <div class="card customer-service-search-border no-padding">
        <div class="row">
            <div class="col-md-12 margintop-32">
                <div class="col-md-8">
                    <div class="row">
                        <div class="form-group col-md-6 col-md-1">
                        </div>
                        <div class="form-group col-md-3">
                            <label class="fnt-blue">
                                {{'ticketing-system.Priority' |translate | translateKey}}
                            </label>&nbsp;:&nbsp;&nbsp;&nbsp;
                            <label>{{ticketingModel.priorityValue}}</label>
                        </div>
                        <div class="form-group col-md-3">
                            <label class="fnt-blue">
                                {{'ticketing-system.Status' |translate | translateKey}}
                            </label>&nbsp;:&nbsp;&nbsp;&nbsp;
                            <label> {{ticketingModel.statusValue}}</label>
                        </div>
                        <div class="form-group col-md-4">
                            <label class="fnt-blue">
                                {{'ticketing-system.Due Date' | translate | translateKey}}
                            </label>&nbsp;:&nbsp;&nbsp;&nbsp;
                            <label>{{ticketingModel.dueDate | date: 'dd-MMM-yyyy'}}</label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-group  col-md-1">
                        </div>
                        <div class="form-group col-md-8">
                            <label class="fnt-blue">
                                {{'ticketing-system.Description' |translate | translateKey}}
                            </label>&nbsp;:&nbsp;&nbsp;&nbsp;
                            <label>{{ticketingModel.description | replaceLinks}}</label>
                        </div>
                    </div>
                    <!--Add Notes-->
                    <div class="row" *ngIf ="([FBOManageTicketPermissions[2]] | hasAccess : customerServiceAccessLevelId)">
                        <div class="form-group  col-md-1">
                        </div>
                        <div class="form-group col-md-8">
                            <label class="fnt-blue">
                                {{'ticketing-system.Note' |translate | translateKey}}
                                <!-- <span  class="ico-help fa fa-question-circle" title="Note"></span> -->
                            </label>
                        </div>
                    </div>
                    <div class="row" *ngIf ="([FBOManageTicketPermissions[2]] | hasAccess : customerServiceAccessLevelId)">
                        <div class="form-group  col-md-1 ticket-color-validation">
                        </div>
                        <div class="form-group col-md-11  textarea-msg">
                            <textarea #focus
                             tabindex="0" class="form-control" [ngClass]="{'showNoteReq':showNoteReq}" rows="4" [(ngModel)]="noteModel.value" (ngModelChange)="checkNote()" placeholder=""></textarea>
                            <div class="alert-msg" *ngIf="showNoteReq">
                                <div>
                                    {{'validation-message.Please Enter Data...'|translate | translateKey}}
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row" *ngIf ="([FBOManageTicketPermissions[2]] | hasAccess : customerServiceAccessLevelId)">
                        <div class="form-group  col-md-1"></div>
                        <div class="form-group col-md-11">
                                <div class="btn-group  btn-save-new pull-right">
                                    <button tabindex="0" class="btn btn-default btn-save" (click)="saveNote()" type="submit"><i class="fa fa-check pad-r-8"></i>{{'ticketing-system.Add Note' |translate | translateKey}}</button>
                                </div>
                        </div>
                    </div>
                    <!--Add attachemnt-->
                    <div class="row" *ngIf="([FBOManageTicketPermissions[2]] | hasAccess : customerServiceAccessLevelId)">
                        <div class="form-group  col-md-1"></div>
                        <div class="form-group col-md-11">
                            <label class="fnt-blue" for="Attach Files">{{'ticketing-system.Attach Files' |translate | translateKey}}
                                <!-- <span title="{{'ticketing-system.Attach Files'|translate}}" class="ico-help fa fa-question-circle"></span> -->
                            </label>
                            <label tabindex="0" (keyup.enter)="fileSelect.click()" class="mar-right10 line-height2 btn btn-xs browse-btn" title="{{'ticketing-system.Choose File'|translate | translateKey}}">
                                <span aria-hidden="true">{{'ticketing-system.Choose File'|translate}}</span>
                                <input #fileSelect type="file" ng2FileSelect [uploader]="uploader" [disabled]="this.attachmentsLength==5" (change)="checkMaxAttachments()"
                                    role="file" aria-label="browse" aria-label="" style="display: none;" multiple>
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group  col-md-1"></div>
                        <div class="form-group   col-md-11 pad-top-10">
                            <div class="table-section">
                                <div>
                                    <table class="table table-striped custab">
                                        <thead>
                                            <tr>
                                                <th class="col-md-10">{{'ticketing-system.File Name' |translate | translateKey}}&nbsp;</th>
                                                <th>{{'ticketing-system.Actions' |translate}}&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody *ngIf="existFiles?.length">
                                            <tr *ngFor="let item of existFiles,let i=index">
                                                <td>{{item.fileName}}</td>
                                                <td class="options">
                                                    <i style="color: #337ab7;" class="fa text-primary fa-download font16" (click)="downloadDocument(item.url,item.fileName)" title="{{'ticketing-system.download'|translate}}">
                                                    </i>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody *ngIf="uploader?.queue?.length">
                                            <tr *ngFor="let item of uploader.queue">
                                                <td>{{ item?.file?.name }}</td>
                                                <td class="options">
                                                    <i class="line-height1-2 fa fa-trash btn-del" tabindex="0" (keyup.enter)="item.remove();attachmentsLength= attachmentsLength-1;" (click)="item.remove();attachmentsLength= attachmentsLength-1;" title="{{'ticketing-system.Delete'|translate}}">
                                                    </i>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody *ngIf="uploader?.queue?.length === 0 && existFiles.length === 0">
                                            <tr>
                                                <td colspan="2" class="text-align-center">{{'ticketing-system.No Attachments' |translate | translateKey}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="([FBOManageTicketPermissions[2]] | hasAccess : customerServiceAccessLevelId)">
                        <div class="form-group  col-md-1"></div>
                        <div class="form-group col-md-11">
                            <div class="btn-group  btn-save-new pull-right" *ngIf="uploader?.queue?.length != 0">
                                <button class="btn btn-default btn-save" tabindex="0" (keyup.enter)="attachFiles()" (click)="attachFiles()" type="button">
                                    <i class="fa fa-check pad-r-8"></i>{{'ticketing-system.Save Attachment' |translate | translateKey}}</button>
                            </div>
                        </div>
                    </div>
                    <!--</div>-->

                    <div class="row">
                        <div class="form-group col-md-1">
                        </div>
                        <div class="form-group  col-md-4">
                            <ul role="tablist" class="" style="list-style-type:none;padding-left:0px;">
                                <li class="margin-r-30" role="presentation">
                                    <label class="historyLink" tabindex="0" (keyup.enter)="active= !active;showHistory=true;showNotes=false;" (click)="active= !active;showHistory=true;showNotes=false;" [ngClass]="{'activehistory':!active}">
                                        <a>{{'ticketing-system.History' |translate | translateKey}}</a>
                                    </label>
                                    <label tabindex="0" (keyup.enter)="active= !active;showNotes=true;showHistory=false;" (click)="active= !active;showNotes=true;showHistory=false;" class="historyLink" [ngClass]="{'activehistory':active}">
                                        <a>{{'ticketing-system.Notes' |translate | translateKey}}</a>
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-6 col-md-1">
                        </div>
                        <div class="form-group col-md-12 col-md-9">
                            <div *ngFor="let history of ticketingModel.notes">
                                <div class="notes" *ngIf="showHistory&&ticketingModel.notes">
                                    <div class="form-group">
                                        <label>
                                            {{history.createdDate | date: 'dd-MMM-yyyy HH:mm:ss'}}&nbsp;&nbsp;{{history.createdByValue}}
                                        </label>
                                    </div>
                                    <div class="form-group">
                                        <label>
                                            {{history.value}}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="showNotes&&ticketingModel.notes">
                                <div *ngFor="let note of ticketingModel.notes">
                                    <div class="notes">
                                        <div class="form-group">
                                            <label [innerHTML]="note.value | safeHtml">
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                          <div  class=" col-md-1"></div>
                           <div class=" col-md-11 no-padding">
                              <ng-container *ngTemplateOutlet="ticketActivityLogInfo"></ng-container>
                            </div>
                    </div>
                    <!--end history and notes-->
                </div>
                <div class="col-md-4">
                    <ng-container *ngTemplateOutlet="ticketInfo"></ng-container>
                </div>
            </div>
          
        </div>
    </div>
</div>
<!--show View ticket End-->

<!--Show Edit Ticket-->
<div *ngIf="showEditTicket && ticketEditForm">
    <form [formGroup]="ticketEditForm" style="padding:0px;" class="col-xs-12  ticket-color-validation" novalidate (ngSubmit)="checkForValidationAndUpdate(ticketEditForm.value)">
        <div class="page-heading">
            <!-- <span>{{'ticketing-system.Ticket' |translate}} - </span> -->
            <span style="color:#0f7bb6">{{ticketinputvalue}}</span>
            <a tabindex="3" (keyup.enter)="resetVariables();showViewTicket = true;showEditTicket = false;getTicketById(ticketId,true)" (click)="resetVariables();showViewTicket = true;showEditTicket = false;getTicketById(ticketId,true)" class="backlink backuser-btn"
                style="font-size:14px!important;cursor:pointer;">
                <i class="fa fa-arrow-circle-left pad-r-8"></i>&nbsp;{{'ticketing-system.Go to View Ticket' |translate | translateKey}}
            </a>
            <a class="backlink backuser-btn hide" data-toggle="tab" href="#shipping-methods" role="tab">
                <i class="fa fa-arrow-circle-left pad-r-8"></i>
                <span class="back-title"></span>
            </a>
            <div class="pull-right">
                <div class="btn-group  btn-save-new">
                    <button class="btn btn-default btn-save" tabindex="2" type="submit">
                        <i class="fa fa-check pad-r-8"></i>{{'ticketing-system.Update' |translate | translateKey}}</button>
                </div>
                <button tabindex="2" (keyup.enter)="resetVariables();showViewTicket = true;showEditTicket = false;getTicketById(ticketId,true)" (click)="resetVariables();showViewTicket = true;showEditTicket = false;getTicketById(ticketId,true)" class="btn cancel btn-cancel"
                    type="button">
                    <i class="fa fa-close pad-r-8"></i>{{'ticketing-system.Cancel' |translate | translateKey}}
                </button>
            </div>
        </div>
        <div class="title-underline"></div>
        <div class="card customer-service-search-border no-padding">
            <div class="row">
                <div class="col-md-12 margintop-32">
                    <div class="col-md-8">
                        <div class="row">
                            <div class="form-group col-xs-12 col-md-4">
                                <label for="{{'ticketing-system.Priority' |translate}}">{{'ticketing-system.Priority' |translate | translateKey}}
                                    <!-- <span class="ico-help fa fa-question-circle" title="{{'ticketing-system.Priority' |translate}}"></span> -->
                                </label>
                                <select class="form-control" autofocus #focusPriority tabindex="0" formControlName="priority">
                                    <option value="">--{{'ticketing-system.Select' |translate}}--</option>
                                    <option *ngFor="let priorityType of ticketPriorities" value="{{priorityType.id}}">{{priorityType.value}}</option>
                                </select>
                                <div class="alert-msg" *ngIf="!ticketEditForm.controls['priority'].valid && ticketEditForm.controls['priority'].hasError('required') &&(ticketEditForm.controls['priority'].touched|| isSubmitted)">
                                    <div *ngIf="ticketEditForm.controls['priority'].errors.required">
                                        {{'validation-message.Priority is required'|translate}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-md-4">
                                <label for="{{'ticketing-system.Status' |translate}}">{{'ticketing-system.Status' |translate | translateKey}}
                                    <!-- <span class="ico-help fa fa-question-circle" title="{{'ticketing-system.Status' |translate}}"></span> -->
                                </label>
                                <select #statusType class="form-control" tabindex="0" formControlName="status">
                                    <option value="">--{{'ticketing-system.Select' |translate | translateKey}}--</option>
                                    <option *ngFor="let statusType of statusTypes" value="{{statusType.id}}">{{statusType.value}}</option>
                                </select>
                                <div class="alert-msg" *ngIf="!ticketEditForm.controls['status'].valid && ticketEditForm.controls['status'].hasError('required') &&(ticketEditForm.controls['status'].touched|| isSubmitted)">
                                    <div *ngIf="ticketEditForm.controls['status'].errors.required">
                                        {{'validation-message.Status is required'|translate | translateKey}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-md-4">
                                <label for="{{'ticketing-system.Due Date' | translate | translateKey}}">{{'ticketing-system.Due Date' | translate | translateKey}}
                                    <!-- <span class="ico-help fa fa-question-circle" title="{{'ticketing-system.Due Date' |translate}}"></span> -->
                                </label>
                                <div class="input-group registration-date-time" style="cursor: pointer;padding-right: 10px;">
                                    <span class="input-group-addon" id="">
                                        <span class="glyphicon glyphicon-calendar" aria-hidden="true"></span>
                                    </span>
                                    <input   class=" form-control"  formControlName="dueDate" bsDatepicker (bsValueChange)="onDateChange($event,'dueDate')" [bsConfig]="{ dateInputFormat: 'DD-MMM-YYYY', containerClass: 'theme-dark-blue' }"
                                     [attr.disabled]="this.ticketEditForm.controls['assignedTo'].value ? null : ''" [bsValue]="bsValue | date: 'dd-MMM-yyyy'"  placeholder="{{'ticketing-system.To Date (DD-MMM-YYYY)' |translate}}">
                                     <!-- <input class="form-control" type="text" tabindex="0" readonly style ="background-color: white;" dateTimePicker [autoClose]="true" [pickerType]="'date'" formControlName="dueDate"
                                        [value]="ticketEditForm.controls['dueDate'].value | date: 'dd-MMM-yyyy'" [mode]="'dropdown'"  [attr.disabled]="ticketEditForm.controls['assignedTo'].value?null:''"
                                        [minMoment]="date" (onChange)="onDateChange($event,'dueDate')" placeholder="DD-MMM-YYYY"> -->
                                    <span class="input-group-addon" (click)="onDateClear()">X</span>

                                </div>
                                <div class="alert-msg" *ngIf="!ticketEditForm.controls['dueDate'].valid && ticketEditForm.controls['dueDate'].hasError('required') &&(ticketEditForm.controls['dueDate'].touched|| isSubmitted)">
                                    <div *ngIf="ticketEditForm.controls['dueDate'].errors.required">
                                        {{'validation-message.Due Date is required'|translate | translateKey}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-xs-12 col-md-4">
                                <label for="{{'ticketing-system.Ticket Type' |translate}}">{{'ticketing-system.Ticket Type' |translate | translateKey}}
                                    <!-- <span class="ico-help fa fa-question-circle" title="{{'ticketing-system.Ticket Type' |translate}}"></span> -->
                                </label>
                                <select class="form-control" formControlName="ticketType" tabindex="0" (change)="getSubTypes($event.target.value,true)">
                                    <option value="">--{{'ticketing-system.Select' |translate}}--</option>
                                    <option *ngFor="let ticketType of ticketTypes" [value]="ticketType.id">{{ticketType.value}}</option>
                                </select>
                                <div class="alert-msg" *ngIf="!ticketEditForm.controls['ticketType'].valid && ticketEditForm.controls['ticketType'].hasError('required') &&(ticketEditForm.controls['ticketType'].touched|| isSubmitted)">
                                    <div *ngIf="ticketEditForm.controls['ticketType'].errors.required">
                                        {{'validation-message.Ticket Type is required'|translate | translateKey}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-md-4">
                                <label for="{{'ticketing-system.SubType' |translate}}">{{'ticketing-system.SubType' |translate | translateKey}}
                                    <!-- <span class="ico-help fa fa-question-circle" title="{{'ticketing-system.Sub Type' |translate}}"></span> -->
                                </label>
                                <select #subType class="form-control" formControlName="subType" tabindex="0" (change)="subTypeChange(subType.value,true)">
                                    <option value="">--{{'ticketing-system.Select' |translate | translateKey}}--</option>
                                    <option *ngFor="let subType of subTypes | orderBy : 'name'" [value]="subType.id">{{subType.name}}</option>
                                </select>
                                <div class="alert-msg" *ngIf="!ticketEditForm.controls['subType'].valid && ticketEditForm.controls['subType'].hasError('required') &&(ticketEditForm.controls['subType'].touched|| isSubmitted)">
                                    <div *ngIf="ticketEditForm.controls['subType'].errors.required">
                                        {{'validation-message.SubType is required'|translate | translateKey}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-md-4" *ngIf="showOrderField">
                                <label *ngIf="!isDisputeTicket" for="Order Number">{{'ticketing-system.Order Number' |translate}}
                                    <!-- <span class="ico-help fa fa-question-circle" title="Order Number"></span> -->
                                </label>
                                <label *ngIf="isDisputeTicket" for="Web Order Number">{{'ticketing-system.Web Order Id' |translate}}
                                    <!-- <span class="ico-help fa fa-question-circle" title="Web Order Number"></span> -->
                                </label>
                                <input type="text" tabindex="0" class="form-control" formControlName="orderId" tabindex="0"
                                />
                                <div class="alert-msg" *ngIf="!ticketEditForm.controls['orderId'].valid && ticketEditForm.controls['orderId'].hasError('required') &&(ticketEditForm.controls['orderId'].touched|| isSubmitted)">
                                    <div *ngIf="ticketEditForm.controls['orderId'].errors.required">
                                        {{'validation-message.Order Number is required'|translate | translateKey}}
                                    </div>

                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-md-4" *ngIf="showLocationTypeField">
                                <label for="Location Type">{{'ticketing-system.Location Type' |translate | translateKey}}
                                    <!-- <span class="ico-help fa fa-question-circle" title="Location Type"></span> -->
                                </label>
                                <select tabindex="0" formControlName="locationTypeId" class="form-control">
                                    <option value="">--{{'ticketing-system.Select' |translate | translateKey}}--</option>
                                    <option *ngFor="let locationType of locationTypes | orderBy : 'value'" [value]="locationType.id">{{locationType.value}}</option>
                                </select>
                                <div class="alert-msg" *ngIf="ticketEditForm.controls['locationTypeId'].valid && ticketEditForm.controls['locationTypeId'].hasError('required') &&(ticketEditForm.controls['locationTypeId'].touched|| isSubmitted)">
                                    {{'validation-message.Location Type is required'|translate | translateKey}}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-xs-12 col-md-4">
                                <label for="{{'ticketing-system.Assign to Department' |translate}}">{{'ticketing-system.Assign to Department' |translate | translateKey}}
                                    <!-- <span class="ico-help fa fa-question-circle" title="{{'ticketing-system.Department' |translate}}"></span> -->
                                </label>
                                <select #departmentType class="form-control" formControlName="department" tabindex="0" (change)="getAssignedUsersByDepartments(departmentType.value,true)">
                                    <option value="">--{{'ticketing-system.Select' |translate | translateKey}}--</option>
                                    <option *ngFor="let department of departments" [value]="department.id">{{department.value}}</option>
                                </select>
                                <div class="alert-msg" *ngIf="!ticketEditForm.controls['department'].valid && ticketEditForm.controls['department'].hasError('required') &&(ticketEditForm.controls['department'].touched|| isSubmitted)">
                                    <div *ngIf="ticketEditForm.controls['department'].errors.required">
                                        {{'validation-message.Department Name is required'|translate | translateKey}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-md-4">
                                <label for="{{'ticketing-system.Assign to User' |translate}}">{{'ticketing-system.Assign to User' |translate | translateKey}}
                                    <!-- <span class="ico-help fa fa-question-circle" title="{{'ticketing-system.Assign To' |translate}}"></span> -->
                                </label>
                                <span *ngIf="isTicketSelfAssignPermission">
                                    <label for="{{'ticketing-system.Assign To Me' |translate}}">{{'ticketing-system.Assign To Me' |translate | translateKey}}
                                        <!-- <span class="ico-help fa fa-question-circle" title="{{'ticketing-system.Assign To Me' |translate}}"></span> -->
                                    </label>
                                    <input type="checkbox" formControlName="assignToMe" tabindex="0" (change)="checkAssignToMe($event.target.value)" tabindex="0" />
                                </span>
                                <!--<input type="text" class="form-control" formControlName="assignedTo" tabindex="0"/>-->
                                <select tabindex="0" formControlName="assignedTo" class="form-control" (change)="onAssignToChange($event.target.value)">
                                    <option value ="" [selected]="true">--{{'ticketing-system.Select' |translate | translateKey}}--</option>
                                    <option *ngFor="let user of users" [ngValue]="user.id">{{user.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-xs-12 col-md-4" *ngIf="isDisputeTicket && isEntireOrder">
                                <label for="{{'ticketing-system.Dispute Reason' |translate}}">{{'ticketing-system.Dispute Reason' |translate | translateKey}}
                                    <!-- <span class="ico-help fa fa-question-circle" title="{{'ticketing-system.Dispute Reason' |translate}}"></span> -->
                                </label>
                                <select tabindex="0" formControlName="orderReasonReasonId" class="form-control" (change)="onDisputeReasonChange()">
                                    <option value="">--{{'ticketing-system.Select' |translate}}--</option>
                                    <option *ngFor="let reason of disputeReasons" [value]="reason.id">{{reason.value}}</option>
                                </select>
                                <div class="alert-msg" *ngIf="!ticketEditForm.controls['orderReasonReasonId'].valid && ticketEditForm.controls['orderReasonReasonId'].hasError('required') &&(ticketEditForm.controls['orderReasonReasonId'].touched|| isSubmitted)">
                                    <div *ngIf="ticketEditForm.controls['orderReasonReasonId'].errors.required">
                                        {{'validation-message.Dispute Reason are required'|translate | translateKey}}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-md-8" *ngIf="isDisputeTicket && showDisputeReasonField">
                                <label for="{{'ticketing-system.Dispute Reason Details' |translate}}">{{'ticketing-system.Dispute Reason Details' |translate | translateKey}}
                                    <!-- <span class="ico-help fa fa-question-circle" title="{{'ticketing-system.Dispute Reason Details' |translate}}"></span> -->
                                </label>
                                <input tabindex="0" type="text" formControlName="orderReasonNotes" class="form-control" placeholder="">
                                <div class="alert-msg" *ngIf="!ticketEditForm.controls['orderReasonNotes'].valid && ticketEditForm.controls['orderReasonNotes'].hasError('required') &&(ticketEditForm.controls['orderReasonNotes'].touched|| isSubmitted)">
                                    <div *ngIf="ticketEditForm.controls['orderReasonNotes'].errors.required">
                                        {{'validation-message.Dispute Reason Details are required'|translate | translateKey}}
                                    </div>
                                </div>
                            </div>
                            <!--<div class="form-group col-xs-12 col-md-4">
                                    <label for="{{'ticketing-system.Assign To Me' |translate}}">{{'ticketing-system.Assign To Me' |translate}}
                                            <span  class="ico-help fa fa-question-circle" title="{{'ticketing-system.Assign To Me' |translate}}"></span>
                                    </label>
                                    <div>
                                    <input type="checkbox" formControlName="assignToMe" tabindex="0"/>
                                    </div>
                                </div>-->
                        </div>
                        <div class="form-group col-xs-12 col-md-8 no-padding">
                            <label for="{{'ticketing-system.Subject' |translate}}">{{'ticketing-system.Subject' |translate | translateKey}}
                                <!-- <span class="ico-help fa fa-question-circle" title="{{'ticketing-system.Subject' |translate}}"></span> -->
                            </label>
                            <div>
                                <input type="text" class="form-control" tabindex="0" placeholder="" rows="3" formControlName="subject" />
                                <div class="alert-msg" *ngIf="!ticketEditForm.controls['subject'].valid && ticketEditForm.controls['subject'].hasError('required') &&(ticketEditForm.controls['subject'].touched|| isSubmitted)">
                                    <div *ngIf="ticketEditForm.controls['subject'].errors.required">
                                        {{'validation-message.Subject is required'|translate}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-md-8 no-padding">
                            <label for="{{'ticketing-system.Description' |translate}}">{{'ticketing-system.Description' |translate | translateKey}}
                                <!-- <span class="ico-help fa fa-question-circle" title="{{'ticketing-system.Description' |translate}}"></span> -->
                            </label>
                            <div class=" textarea-msg">
                                <textarea class="form-control overflow-x-hidden" tabindex="0" formControlName="description" id="Description" placeholder="" cols="60"
                                    rows="3"></textarea>
                                <div class="alert-msg" *ngIf="!ticketEditForm.controls['description'].valid && ticketEditForm.controls['description'].hasError('required') &&(ticketEditForm.controls['description'].touched|| isSubmitted)">
                                    <div *ngIf="ticketEditForm.controls['description'].errors.required">
                                        {{'validation-message.Description is required'|translate | translateKey}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="([FBOManageTicketPermissions[2]] | hasAccess : customerServiceAccessLevelId)" class="form-group col-xs-12 col-md-8 no-padding">
                            <label for="{{'ticketing-system.Note' |translate}}">{{'ticketing-system.Note' |translate | translateKey}}
                                <!-- <span class="ico-help fa fa-question-circle" title="{{'ticketing-system.Note' |translate}}"></span> -->
                            </label>
                            <div>
                                <textarea class="form-control" tabindex="0" placeholder="" rows="3" formControlName="note"></textarea>
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-md-12 no-padding" *ngIf="!isEntireOrder && items && items.length > 0">
                            <!-- <div class="alert-msg" *ngIf="formInvalid">
                                {{'ticketing-system.Please select atleast one Line item' |translate}}</div> -->
                            <div class="form-group col-md-4 padding-left-zero">
                                <label class="bold">{{'ticketing-system.Dispute Individual Item' |translate | translateKey}}</label>
                            </div>
                            <div class="form-group col-md-7 pull-right">
                                <div class="col-md-8 right-padding-0">
                                    <label for="Select Reason">{{'ticketing-system.Apply to all selected Line items' |translate | translateKey}}
                                    </label>
                                </div>
                                <div class="col-md-4 right-padding-0">
                                    <select tabindex="0" class="form-control" tabindex="0" (change)="setReasonForAllItems($event)">
                                        <option value="">--{{'ticketing-system.Select' |translate}}--</option>
                                        <option *ngFor="let reason of disputeReasons" [value]="reason.id">{{reason.value}}</option>
                                    </select>
                                </div>
                            </div>
                            <table class="table table-striped custab">
                                <thead id="tHead">
                                    <tr>
                                        <th width="5%"></th>
                                        <th width="10%"> {{'ticketing-system.#Sku' |translate | translateKey}}</th>
                                        <th width="25%">{{'ticketing-system.Product Description' |translate | translateKey}}</th>
                                        <th width="5%">{{'ticketing-system.Qty' |translate}}</th>
                                        <th width="15%">{{'ticketing-system.Already Disputed Qty' |translate | translateKey}}</th>
                                        <th width="15%">{{'ticketing-system.New Dispute Qty' |translate | translateKey}}</th>
                                        <th width="25%"> {{'ticketing-system.Reason' |translate | translateKey}}</th>
                                    </tr>
                                </thead>
                                <tbody formArrayName="items" *ngFor="let item of ticketEditForm.get('items').controls; let i = index;">
                                    <tr class="items" [formGroupName]="i">
                                        <td width="5%">
                                            <span *ngIf="item.controls['include'].value === true">
                                                <i class="fa fa-check-circle fa-lg"></i>
                                            </span>
                                        </td>
                                        <td width="10%">{{ticketEditForm.controls['items'].controls[i].controls['itemNumber'].value}}</td>
                                        <td width="25%">{{ticketEditForm.controls['items'].controls[i].controls['productDescription'].value}}
                                        </td>
                                        <td width="5%">{{ticketEditForm.controls['items'].controls[i].controls['quantity'].value}}</td>
                                        <td width="15%">{{ticketEditForm.controls['items'].controls[i].controls['alreadyDisputedQuantity'].value}}</td>

                                        <input type="hidden" value="" formControlName="include" class="" placeholder="">
                                        <input type="hidden" class="form-control" formControlName="createdBy" class="" placeholder="">
                                        <input type="hidden" class="form-control" formControlName="modifiedBy" class="" placeholder="">
                                        <input type="hidden" class="form-control" formControlName="itemNumber" class="" placeholder="">
                                        <input type="hidden" class="form-control" formControlName="quantity" class="" placeholder="">
                                        <input type="hidden" class="form-control" formControlName="productDescription" class="" placeholder="">
                                        <input type="hidden" class="form-control" formControlName="alreadyDisputedQuantity" class="" placeholder="">
                                        <td width="15%">
                                            <input type="number" min="0" class="form-control" tabindex="0" onpaste="return false" (keypress)="selectItem($event, i)" (keyup.backspace)="onBackspace($event,i)" (change)="selectItem($event, i)"
                                                formControlName="newDisputedQuantity" placeholder="">
                                            <!-- <div class="alert-msg" *ngIf="!item.controls['newDisputedQuantity'].valid && item.controls['newDisputedQuantity'].errors.required && (item.controls['newDisputedQuantity'].touched|| isSubmitted)">
                                                {{'Required' |translate}}</div>
                                            <div class="alert-msg" *ngIf="!item.controls['newDisputedQuantity'].valid && item.controls['newDisputedQuantity'].errors.quantityValidation && (item.controls['newDisputedQuantity'].touched|| isSubmitted)">
                                                {{'Invalid Qty' |translate}}</div>
                                            <div class="alert-msg" *ngIf="!item.controls['newDisputedQuantity'].valid">
                                                {{'Invalid Qty' |translate}}</div> -->
                                        </td>
                                        <td width="25%">
                                            <select tabindex="0" class="form-control" formControlName="ticketDisputeReasonId" (change) = "onDisputeReasonChange()">
                                                <option value="">--{{'ticketing-system.Select' |translate | translateKey}}--</option>
                                                <option *ngFor="let reason of disputeReasons" [ngValue]="reason.id">{{reason.value}}</option>
                                            </select>
                                            <div class="alert-msg" *ngIf="!item.controls['ticketDisputeReasonId'].valid && item.controls['ticketDisputeReasonId'].errors.required && (item.controls['ticketDisputeReasonId'].touched|| isSubmitted)">
                                                {{'Required' |translate}}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-xs-12 no-padding form-group" >
                            <div class="table-section" *ngIf="individualOrderType && ticketEditForm.controls['subType'].value == disputeOrder">
                                <label class="bold">{{'ticketing-system.Order Details' |translate | translateKey}}</label>
                                <table class="table table-striped custab">
                                    <thead id="tHead">
                                        <tr>
                                            <th>{{'ticketing-system.#Sku' |translate | translateKey}}</th>
                                            <th>{{'ticketing-system.Product Description' |translate | translateKey}}</th>
                                            <th>{{'ticketing-system.Qty' |translate | translateKey}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of ticketingModel.disputes">
                                            <td>{{item.itemNumber}}</td>
                                            <td>{{item.productDescription}} </td>
                                            <td>{{item.quantity}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-xs-12 no-padding form-group" >
                            <div class="table-section" *ngIf="ticketEditForm.controls['subType'].value == disputeOrder && entireOrderType && isEntireOrder">
                                <label class="bold">{{'ticketing-system.Order Details' |translate | translateKey}}</label>
                                <table class="table table-striped custab">
                                    <thead id="tHead">
                                        <tr>
                                            <th>{{'ticketing-system.#Sku' |translate | translateKey}}</th>
                                            <th>{{'ticketing-system.Product Description' |translate | translateKey}}</th>
                                            <th>{{'ticketing-system.Qty' |translate | translateKey}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of orderInfo">
                                            <td>{{item.sku}}</td>
                                            <td>{{item.productDescription}} </td>
                                            <td>{{item.quantity}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                       
                        <div *ngIf="([FBOManageTicketPermissions[2]] | hasAccess : customerServiceAccessLevelId)" class="form-group col-xs-12 col-md-8 no-padding">
                            <div class="">
                                <label class="fnt-blue" for="Attach Files">{{'ticketing-system.Attach Files' |translate | translateKey}}
                                    <!-- <span title="{{'ticketing-system.Attach Files'|translate}}" class="ico-help fa fa-question-circle"></span> -->
                                </label>
                                <label tabindex="0" (keyup.enter)="fileSelect.click()" class="mar-left10 line-height2 btn btn-xs browse-btn" title="{{'ticketing-system.Choose File' |translate}}">
                                    <span aria-hidden="true">{{'ticketing-system.Choose File' |translate | translateKey}}</span>
                                    <input #fileSelect type="file" ng2FileSelect [uploader]="uploader" [disabled]="this.attachmentsLength==5" (change)="checkMaxAttachments()"
                                        role="file" aria-label="browse" aria-label="" style="display: none;" multiple>
                                </label>

                                <!--<label class="mar-left10 line-height2 btn btn-xs browse-btn" title="{{'ticketing-system.Choose File' |translate}}">
                                            <span aria-hidden="true">{{'ticketing-system.Choose File' |translate}}</span>
                                            <input type="file" ng2FileSelect [uploader]="uploader" [disabled]="this.attachmentsLength==5" (change)="checkMaxAttachments()" role="file" aria-label="browse" tabindex="0" aria-label="" 
                                                style="display: none;" multiple>
                                        </label>-->
                            </div>
                        </div>
                        <div class="form-group col-xs-12 col-md-8 pad-top-10 no-padding">
                            <div class="table-section">
                                <div>
                                    <table class="table table-striped custab">
                                        <thead>
                                            <tr>
                                                <th class="col-md-10">{{'ticketing-system.File Name' |translate | translateKey}}&nbsp;</th>
                                                <th>{{'ticketing-system.Actions' |translate | translateKey}}&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody *ngIf="uploader?.queue?.length">
                                            <tr *ngFor="let item of uploader.queue">
                                                <td>{{ item?.file?.name }}</td>
                                                <td class="options">
                                                    <!--<i type="button" class="upload-icon glyphicon glyphicon-upload" title="{{'ticketing-system.Upload'|translate}}" (click)="item.upload()">
                                                                </i>-->
                                                    <!-- <button type="button" class="btn btn-success btn-xs" (click)="item.upload()" [disabled]="item.isReady || item.isUploading || item.isSuccess">
                                                                    <i class="glyphicon glyphicon-upload"></i>
                                                                </button> -->
                                                    <i class="line-height1-2 fa fa-trash btn-del" (click)="item.remove();attachmentsLength= attachmentsLength-1;" title="{{'ticketing-system.Delete'|translate}}">
                                                    </i>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody *ngIf="existFiles?.length">
                                            <tr *ngFor="let item of existFiles,let i=index">
                                                <td>{{item.fileName}}</td>
                                                <td class="options">
                                                    <!--<i type="button" class="upload-icon glyphicon glyphicon-upload" title="{{'ticketing-system.Upload'|translate}}" (click)="item.upload()">
                                                                </i>-->
                                                    <!-- <button type="button" class="btn btn-success btn-xs" (click)="item.upload()" [disabled]="item.isReady || item.isUploading || item.isSuccess">
                                                                    <i class="glyphicon glyphicon-upload"></i>
                                                                </button> -->
                                                    <i style="color: #337ab7;" class="fa text-primary fa-download pr-10 font16" (click)="downloadDocument(item.url,item.fileName)" title="{{'ticketing-system.download '|translate | translateKey}}">
                                                    </i>
                                                    <i class="line-height1-2 fa fa-trash btn-del font16" (click)="removeExistFiles(item.key,i)" title="{{'ticketing-system.Delete'|translate}}">
                                                    </i>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody *ngIf="uploader?.queue?.length === 0 && existFiles.length === 0">
                                            <tr>
                                                <td colspan="2" class="text-align-center">{{'ticketing-system.No Attachments' |translate | translateKey}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                                                  
                        <div class="form-group col-xs-12 col-md-8">
                            <ul role="tablist" class="" style="list-style-type:none;padding-left:0px;">
                                <li class="margin-r-30" role="presentation">
                                    <label class="historyLink" tabindex="0" (keyup.enter)="active= !active;showHistory=true;showNotes=false;" (click)="active= !active;showHistory=true;showNotes=false;" [ngClass]="{'activehistory':!active}">
                                        <a>{{'ticketing-system.History' |translate | translateKey}}</a>
                                    </label>
                                    <label (click)="active= !active;showNotes=true;showHistory=false;" tabindex="0" (keyup.enter)="active= !active;showNotes=true;showHistory=false;" class="historyLink" [ngClass]="{'activehistory':active}">
                                        <a>{{'ticketing-system.Notes' |translate | translateKey}}</a>
                                    </label>
                                </li>
                            </ul>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-12 col-md-9">
                                <div *ngIf="showHistory&&ticketingModel.notes">
                                    <div class="notes" *ngFor="let history of ticketingModel.notes">
                                        <div class="form-group">
                                            <label>
                                                {{history.createdDate | date: 'dd-MMM-yyyy HH:mm:ss'}}&nbsp;&nbsp;{{history.createdByValue}}
                                            </label>
                                        </div>
                                        <div class="form-group">
                                            <label>
                                                {{history.value}}
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="showNotes&&ticketingModel.notes">
                                    <div *ngFor="let note of ticketingModel.notes">
                                        <div class="notes">
                                            <div class="form-group">
                                                <label>
                                                    {{note.value}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      
                           <div class="row ">
                             <div class="col-md-12 ">
                                 <ng-container *ngTemplateOutlet="ticketActivityLogInfo"></ng-container>
                             </div>
                            </div>
                       
                        <!--end history and notes-->
                    </div>
                    <div class="col-md-4">
                        <ng-container *ngTemplateOutlet="ticketInfo"></ng-container>
                    </div>
                   
                </div>
                
            </div>


        </div>
    </form>
</div>
<ng-template #ticketInfo>
    <div>
        <div class="card card-background">
            <div *ngIf="orderSummary">
                <div class="order-summary-header">
                    <span>{{'ticketing-system.Order Summary' |translate | translateKey}}</span>
                </div>
                <div>
                    <div class="row">
                        <div class="col-xs-6">
                            <span>{{'ticketing-system.Order Number' |translate | translateKey}}</span>
                        </div>
                        <div class="col-xs-6">
                            <span>{{orderSummary.orderNumber}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6">
                            <span>{{'ticketing-system.Web Order Number' |translate | translateKey}}</span>
                        </div>
                        <div class="col-xs-6">
                            <span>{{orderSummary.webOrderNumber}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6">
                            <span>{{'ticketing-system.Order Date' |translate | translateKey}}</span>
                        </div>
                        <div class="col-xs-6">
                            <span>{{orderSummary.orderDate | date: 'dd-MMM-yyyy HH:mm:ss'}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6">
                            <span>{{'ticketing-system.Warehouse Name' |translate | translateKey}}</span>
                        </div>
                        <div class="col-xs-6">
                            <span>{{orderSummary.shippingInfo.warehouseName}}</span>
                        </div>
                    </div>
                    <div class="title-underline"></div>
                    <div class="row">
                        <div class="col-xs-12">
                            <span class="order-summary-subheading">{{'ticketing-system.Forever Business Owner' |translate | translateKey}}</span>
                        </div>
                    </div>
                    <div>
                        <span>{{orderSummary.userName}}&nbsp;|&nbsp;{{ticketingModel.memberId | distributorIdFormat}}</span>
                    </div>
                </div>
                <div class="title-underline"></div>
                <div class="order-summary-header">
                    <span>{{'ticketing-system.Delivery' |translate | translateKey}}</span>
                </div>
                <div>
                    <div class="row">
                        <div class="col-xs-6">
                            <span>{{'ticketing-system.Type' |translate | translateKey}}</span>
                        </div>
                        <div class="col-xs-6">
                            <span>{{orderSummary.shippingInfo.shippingMethod}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6">
                            <span>{{'ticketing-system.Address' |translate | translateKey}}</span>
                        </div>
                        <div class="col-xs-6 wrapword">
                            <span>{{orderSummary.shippingInfo.address.addressFirstLine}},&nbsp;{{orderSummary.shippingInfo.address.city}},&nbsp;{{orderSummary.shippingInfo.address.state}},&nbsp;{{orderSummary.shippingInfo.address.zipCode}}&nbsp;{{orderSummary.shippingInfo.address.country}}</span>
                        </div>
                    </div>
                </div>
                <div class="title-underline"></div>
            </div>
            <div class="form-group">
                <label class="fnt-blue">
                    {{'ticketing-system.Created By' |translate | translateKey}}
                </label>
                <div>
                    <label>
                        {{ticketingModel.createdByValue}}&nbsp;|&nbsp;{{ticketingModel.createdDate | date: 'dd-MMM-yyyy HH:mm:ss'}}
                    </label>
                </div>
            </div>
            <!--</div>-->
            <div class="form-group" *ngIf="ticketingModel.updatedByValue">
                <label class="fnt-blue">
                    {{'ticketing-system.Last updated By' |translate | translateKey}}
                </label>
                <div>
                    <label *ngIf="ticketingModel.updatedByValue">
                        {{ticketingModel.updatedByValue}}&nbsp;|&nbsp;{{ticketingModel.updatedDate | date: 'dd-MMM-yyyy HH:mm:ss'}}
                    </label>
                </div>
            </div>
            <div class="form-group">
                <label class="fnt-blue">
                    {{'ticketing-system.Assign to Department' |translate}}&nbsp;|&nbsp;{{'ticketing-system.Assign to User' |translate | translateKey}}
                </label>
                <div>
                    <label>
                        {{ticketingModel.departmentName}}&nbsp;|&nbsp;{{ticketingModel.assignedToValue}}
                    </label>
                </div>
            </div>
            <div class="form-group">
                <label *ngIf="ticketingModel.sourceId == sourceTypesEnum[0]" class="fnt-blue">
                    {{'ticketing-system.Caller Details' |translate}}&nbsp;|&nbsp;{{'ticketing-system.Caller Phone Number' |translate | translateKey}}
                </label>
                <label *ngIf="ticketingModel.sourceId == sourceTypesEnum[1]" class="fnt-blue">
                    {{'ticketing-system.Sender Details' |translate}}&nbsp;|&nbsp;{{'ticketing-system.Sender Email Address' |translate | translateKey}}
                </label>
                <div>
                    <label>
                        {{ticketingModel.callerName}}&nbsp;|&nbsp;<span *ngIf="sourceTypesEnum.Phone === ticketingModel.sourceId">{{ticketingModel.sourceIdentifierValue | mask:phoneNumberFormat}}</span>
                        <span *ngIf="sourceTypesEnum.Email === ticketingModel.sourceId || sourceTypesEnum.Online_Form === ticketingModel.sourceId">{{ticketingModel.sourceIdentifierValue}}</span>
                    </label>
                </div>
            </div>
            <div class="form-group" *ngIf="!orderSummary">
                <label class="fnt-blue">
                    {{'ticketing-system.Forever Bussiness Owner' |translate |translateKey}}
                </label>
                <div>
                    <label>
                        {{ticketingModel.memberId | distributorIdFormat}}
                    </label>
                    <br/>
                    <!--<label>-->
                    <!--<strong *ngIf="ticketingModel.sourceId==6">{{'ticketing-system.Phone' |translate}} : </strong>
                                                                <strong *ngIf="ticketingModel.sourceId==7">{{'ticketing-system.Email' |translate}} : </strong>-->
                    <!--{{ticketingModel.sourceIdentifierValue}}
                                                            </label>-->
                </div>
            </div>
        </div>
    </div>
    <!--<div class="row">-->
    

    <!--<div class="row" *ngIf="isAddAttachment">
                                                <div class="form-group col-md-6 col-md-1"></div>
                                                <div class="form-group col-md-6 col-md-4">
                                                    <label for="Attach Files">Attach Files
                                                        <span title="Attach Files" class="ico-help fa fa-question-circle"></span>
                                                    </label>
                                                    <label class="mar-left10 line-height2 btn btn-xs browse-btn" title="Choose File">
                                                        <span aria-hidden="true">Choose File</span>
                                                        <input type="file" ng2FileSelect [uploader]="uploader" role="file" aria-label="browse" tabindex="0" aria-label="" accept=".doc,.docx,.html,.pdf,.xls,.xlsx,.ppt,.txt"
                                                            style="display: none;" multiple>
                                                    </label>
                                                </div>
                                            </div>-->
</ng-template>

<ng-template #ticketActivityLogInfo>
     <div >
            <div>
                <label class="fnt-blue" >
                    {{'customer-service.Ticket Activity' |translate | translateKey}}
                 </label>

            </div>
            <table class="table table-striped custab">
                <thead>
                    <tr>
                        <th class="pointer">
                            <strong>{{'customer-service.Time Stamp' |translate | translateKey}}&nbsp;
                                <i tabindex="0" (keyup.enter)="sortTableByColumn('createDate')" (click)="sortTableByColumn('createDate')" class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'createDate', 'fa-sort-asc': (sortColumn  == 'createDate' && !isDesc), 'fa-sort-desc': (sortColumn  == 'createDate' && isDesc) }">
                                </i>
                            </strong>
                        </th>
                        <th class="pointer">
                            <strong>{{'customer-service.User' |translate | translateKey}}&nbsp;
                                <i tabindex="0" (keyup.enter)="sortTableByColumn('changedBy')" (click)="sortTableByColumn('changedBy')" class="font-12 fa fa-sort"  [ngClass]="{'fa-sort': sortColumn != 'changedBy', 'fa-sort-asc': (sortColumn  == 'changedBy' && !isDesc), 'fa-sort-desc': (sortColumn  == 'changedBy' && isDesc) }">
                                </i>
                            </strong>
                        </th>
                        <th class="pointer">
                            <strong>{{'customer-service.Action' |translate | translateKey}}&nbsp;
                                <i tabindex="0" (keyup.enter)="sortTableByColumn('actionType')" (click)="sortTableByColumn('actionType')" class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'actionType', 'fa-sort-asc': (sortColumn  == 'actionType' && !isDesc), 'fa-sort-desc': (sortColumn  == 'actionType' && isDesc) }">
                                </i>
                            </strong>
                        </th>
                        <th>
                            <strong>{{'customer-service.Summary' |translate | translateKey}}&nbsp;
                                <i tabindex="0" >
                                </i>
                            </strong>
                        </th>
                        <th>
                            <strong>{{'customer-service.Detail' |translate | translateKey}}&nbsp;
                                <i  tabindex="0" >
                                </i>
                            </strong>
                        </th>
                    </tr>
                </thead>
                <tr *ngFor="let log of ticketActivityLogList | paginate: { itemsPerPage: 5, currentPage: p }">
                    
                    <td>
                        {{log.createDate | date: 'dd-MMM-yyyy HH:mm:ss '}}
                    </td>
                    <td>
                        {{log.changedBy}}
                    </td>
                    <td>
                        {{log.actionType}}
                    </td>
                    <td [innerHTML]="log.summary |safeHtml">
                    </td>
                    <td>
                        <a *ngIf="log.changedData" (click)="openTicketActivityModal(log.changedData)">{{'customer-service.View Details..' |translate}} </a>                    
                    </td>
                </tr>              
                <tr *ngIf="ticketActivityLogList?.length===0" >
                    <td></td>
                    <td></td>
                    <td>{{'customer-service.No records found' |translate | translateKey}}.</td>
                    <td></td>
                    <td></td>
                </tr>
            </table>
            <div style="float:right;">
             <pagination-controls (pageChange)="p = $event"></pagination-controls>
             </div>
        </div>
</ng-template>
<modal #ticketActivityDetailsModal >
    <modal-header>
        <h4 class="color-blue">{{'ticketing-system.TICKET DETAILS' |translate}}</h4>      
    </modal-header>
    <modal-content >
        <div  class="" [innerHTML]="ticketActivityChangeData | safeHtml" >
        </div>
    </modal-content>
    <modal-footer>
        <div class="pull-right">     
            <button class="btn blue-button" type="button" tabindex="0" (keyup.enter)="closeTicketActivityPopup()" (click)="closeTicketActivityPopup()">
                {{'ticketing-system.Ok' |translate | translateKey}}                                                                                              
            </button>
        </div>
    </modal-footer>
</modal>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/view-work-ticket.component.html